import {IOrderLogModel, OrderLogPossibleTypes} from '../../../../../src/@interfaces/models/Order/IOrderLogModel';
import {FormFieldOption} from '../../../../../src/@types/components/Form';
import React from 'react';
import Translate from '../../../../../src/components/Translate/Translate';
import {ITranslateProps} from '../../../../../src/@interfaces/components/Translate/ITranslateProps';
import Comment from '../../../../../src/components/CommentsList/Comment';
import {ICommentModel} from '../../../../../src/@interfaces/models/Comment/ICommentModel';
import app from '../../../../../src/helpers/app';
import OrderStatusRepresentation from '../../../../../src/components/StatusRepresentations/OrderStatusRepresentation';

export type TypicalMessageProps<T extends OrderLogPossibleTypes = string> = {
    model: IOrderLogModel<T>,
    options: Record<string, FormFieldOption[]>,
    optionsKey?: string,
};

export function TypicalMessage<T extends OrderLogPossibleTypes = string>(props: TypicalMessageProps<T> & {
    message?: string,
    choice?: number,
    replace?: ITranslateProps['replace'],
    messageKeysWithStatusId?: string[],
}) {
    const details = props.model.message_details;
    const type = details['@type'];
    const isOrderEvent = type.startsWith('order.');
    const message = props.message ?? type.replace(/\.+?/g, '@');
    const replace: Record<string, any> = {
        id: props.model.loggable_id,
        ...(props.replace ?? {})
    };

    const get = app('dot-accessor').get.bind(app('dot-accessor'));
    const options = props.options?.[props.optionsKey ?? (isOrderEvent ? 'status' : 'productStatuses')];

    props.messageKeysWithStatusId?.forEach(key => {
        const statusId = get(details, key, null) ?? null;
        if (statusId == null) {
            return;
        }

        const status = options?.find(({value}) => value === +statusId) as any;
        const keyName = key.replace(/_id$/ui, '');

        if (status) {
            replace[keyName] = <OrderStatusRepresentation
                    bgColor={status.bg_color}
                    textColor={status.text_color}
                    label={status.label}
            />;
        } else {
            replace[keyName] = statusId ?? replace[keyName];
        }
    });

    const reason = details.reason;

    return <div>
        <Translate
                message={`OrderLogsField.messages.${message}`}
                choice={props.choice}
                replace={replace}
                withComponentsAsReplacements
        />

        {reason ? (
                <div className="mt-2">
                    <Comment
                            model={{created_at: props.model.created_at, message: reason} as ICommentModel}
                            allowToDelete={false}
                    />
                </div>
        ) : null}
    </div>;
}
